import React from 'react';
import { formatLongDate } from '../dateOnly';

// "To Do" dashboard widget: compliance items for this therapist's clients —
// clients who turned 18 while still marked minor, and clients whose portal
// consent paperwork is over a year old. Fed by GET /therapist/client-attention
// (fetched once by the dashboard). Items clear on their own once the profile
// or paperwork is updated.

export default function ClientToDoCard({ data, onOpenProfile }) {
  if (!data) return <div style={mutedStyle}>Loading…</div>;
  const { turned18 = [], staleConsent = [] } = data;
  const total = turned18.length + staleConsent.length;

  if (total === 0) {
    return (
      <div style={{ ...mutedStyle, padding: '10px 4px' }}>
        ✅ All caught up — no client paperwork needs attention.
      </div>
    );
  }

  return (
    <div>
      <div style={{ ...mutedStyle, marginBottom: 8 }}>
        {total} item{total === 1 ? '' : 's'} · these clear on their own once the profile or paperwork is updated.
      </div>

      {turned18.map((c) => (
        <div key={`a-${c.id}`} style={{ ...rowStyle, background: '#fde8e8', border: '1px solid #f5c2c2' }}>
          <div style={{ flex: 1 }}>
            🔞 <strong>{c.client_name}</strong> is now 18 but still marked as a minor —
            update signatures and ROI if needed, then un-check "Is minor" on their profile.
          </div>
          <button type="button" style={btnStyle} onClick={() => onOpenProfile(c.id)}>Open profile</button>
        </div>
      ))}

      {staleConsent.map((c) => (
        <div key={`s-${c.id}`} style={{ ...rowStyle, background: '#fff3cd', border: '1px solid #ffe69c' }}>
          <div style={{ flex: 1 }}>
            📄 <strong>{c.client_name}</strong>'s consent paperwork is over a year old
            (last signed {fmtTimestamp(c.last_consent)}) — send a new intake link to refresh it.
          </div>
          <button type="button" style={btnStyle} onClick={() => onOpenProfile(c.id)}>Open profile</button>
        </div>
      ))}
    </div>
  );
}

// last_consent is a real timestamp (created_at), so a plain Date is correct
// here; only date-only columns need the local-parse treatment.
function fmtTimestamp(ts) {
  if (!ts) return '';
  const dt = new Date(ts);
  if (isNaN(dt)) return '';
  // A date-only string sneaking through would still shift — route it through
  // the safe formatter.
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(ts))) return formatLongDate(ts);
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

const mutedStyle = { color: 'var(--text-muted)', fontSize: 13 };
const rowStyle = {
  display: 'flex', gap: 10, alignItems: 'center',
  borderRadius: 8, padding: '8px 12px', margin: '6px 0', fontSize: 13.5, lineHeight: 1.4,
};
const btnStyle = {
  flexShrink: 0, background: 'var(--primary-color)', color: '#fff', border: 'none',
  borderRadius: 6, padding: '6px 12px', fontWeight: 700, fontSize: 12.5, cursor: 'pointer',
};
